<!--
  A Bulma-styled checkbox field with a label, validation, and two-way binding for the checked value
-->
<template>
  <div class="fieldWrapper">
    <div style="display:flex">
      <label v-if="label" class="label">{{ label }}</label>
      <slot name="top"/>
    </div>

    <p v-if="description" class="mb-2">{{description}}</p>

    <label class="checkbox">

      <input
        ref="inputElem"
        type="checkbox"
        class="mr-3"
        :checked="modelValue"
        @change="onInput()"
        :disabled="isDisabled"
        :class="{ 'is-danger': validator ? !validator(validationId ? validationId : this, modelValue) : false }"
      />
      {{ boxLabel }}
    </label>

    <slot/>
  </div>
</template>

<script setup lang="ts">

import { ref } from "vue";

const props = defineProps<{
  modelValue?: boolean,
  label?: string,
  description?: string,
  boxLabel: string,
  validator?: (fieldId: any, val: any) => boolean,
  validationId?: string,
  isDisabled?: boolean
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
}>();

// The input element where the form field's value will be bound
const inputElem = ref<any>(null);

// Event for two-way binding
const onInput = () => {
  emit('update:modelValue', inputElem.value.checked);
};

</script>

<style scoped>
input[type=checkbox] {
  scale: 150%;
  position: relative;
  left: 0.25rem;
  top: -0.1rem;
}
</style>